// React
import { ReactElement } from 'react';
// Design System
import { Font } from '@utmb/design-system/text/font';
// Types
import { PopupInfosProps } from '@utmb/types/map';
// Styles
import styles from './map.module.scss';

const PopupInfos = (props: PopupInfosProps): ReactElement => {
    const { label, content, measureUnit } = props;

    const labelClassNames = ['lh-14 ls-1', styles.label].filter(Boolean).join(' ');
    const contentClassNames = ['lh-24 ls-1', styles.content].filter(Boolean).join(' ');

    return (
        <div className={styles.infos_wrapper}>
            <Font.OxaniumLight mobile="14" desktop="16" className={labelClassNames}>
                {label}
            </Font.OxaniumLight>
            <Font.OxaniumBold mobile="16" desktop="18" className={contentClassNames}>
                {content}
                {measureUnit && <span>{measureUnit}</span>}
            </Font.OxaniumBold>
        </div>
    );
};

export default PopupInfos;
